import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Rooms from './pages/Rooms';
import Bookings from './pages/Bookings';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/Admin';
import GuestPortal from './pages/GuestPortal';

function App() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const closeNav = () => setIsNavOpen(false);

  return (
    <Router>
      <div className="app">
        <header>
          <nav className="navbar" aria-label="Primary navigation">
            <div className="nav-container">
              <Link to="/" className="logo" aria-label="Visawa Hotel & Resorts home">
                <img src="/logo.png" alt="Visawa Hotel & Resorts logo" width="48" height="48" loading="eager" decoding="async" />
                <span>
                  <strong>Visawa Hotel & Resorts</strong>
                  <small>Luxury Hotel & Resorts</small>
                </span>
              </Link>
              <ul className={`nav-menu ${isNavOpen ? 'open' : ''}`}>
                <li><Link to="/" onClick={closeNav}>Home</Link></li>
                <li><a href="/#facilities" onClick={closeNav}>Services</a></li>
                <li><a href="/#gallery" onClick={closeNav}>Gallery</a></li>
                <li><a href="https://management.visawahotel.in" onClick={closeNav}>Login</a></li>
              </ul>

              <div className="nav-actions">
                <a href="tel:+919301783278" className="phone-pill">+91 93017 83278</a>
                <button
                  className={`menu-toggle ${isNavOpen ? 'open' : ''}`}
                  type="button"
                  aria-label="Toggle navigation menu"
                  aria-expanded={isNavOpen}
                  onClick={() => setIsNavOpen((open) => !open)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </nav>
        </header>

        <main id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rooms" element={<Rooms isLoggedIn={false} />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/portal" element={<GuestPortal />} />
          </Routes>
        </main>

        <footer className="footer" aria-label="Footer">
          <div className="footer-content">
            <p>&copy; 2024 Visawa Hotel & Resorts. All rights reserved.</p>
            <div className="footer-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#contact">Contact Us</a>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
